<template>
  <span class="spinner" :class="{ 'center': center }"><span class="bounce1"></span><span class="bounce2"></span><span
    class="bounce3"></span></span>
</template>

<script>
  export default {
    props: {
      center: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>
